import { $api } from "../generated/client";

export default function useShop(id?: string | null) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}",
		{
			params: { path: { shopId: id! } },
		},
		{
			enabled: !!id,
		},
	);
}
